import * as React from "react";
import Dialog from "@mui/material/Dialog";
import { styled } from '@mui/material/styles';
import InputLabel from "@mui/material/InputLabel";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import OutlinedInput from '@mui/material/OutlinedInput';
import InputAdornment from '@mui/material/InputAdornment';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import FormControl from '@mui/material/FormControl';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import Paper from '@mui/material/Paper';
import MenuList from '@mui/material/MenuList';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import Popover from '@mui/material/Popover';
import Divider from '@mui/material/Divider';
import AdminRoomDeletion from "../RoomModal/AdminRoomDeletion"
import UserExtendingRoomTime from "../RoomModal/UserExtendingRoomTime"
import { ROUTES } from "../../routes/User/paths";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export default function RoomTopMenuOptionsModal({
  roomTopMenuOptionsOpen,
  setRoomTopMenuOptionsOpen,
  classes,
  isCurrentUserMainAdmin,
  roomName,
  roomId
}) {
  const [tabValue, setTabValue] = React.useState("1");
  const [isDeletingRoomAnchorEl, setIsDeletingRoomAnchorEl] = React.useState(null);
  const [isExtendingRoomTimeAnchorEl, setIsExtendingRoomTimeAnchorEl] = React.useState(null);

  // Get current page URL
  const regularModeRoomUrl = `${window.location.origin}${ROUTES.rooms}/${roomId}`;
  const spectatorModeRoomUrl = `${window.location.origin}${ROUTES.spectate}/${roomId}`;

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleCopyClick = (text) => {
    navigator.clipboard.writeText(text)
  }

  const handleAdminDeletionClick = (event) => {
    setIsDeletingRoomAnchorEl(event.currentTarget);
  };

  const handleAdminDeletionClose = () => {
    setIsDeletingRoomAnchorEl(null);
  };

  const handleUserExtendingRoomTimeClick = (event) => {
    setIsExtendingRoomTimeAnchorEl(event.currentTarget);
  };

  const handleUserExtendingRoomTimeClose = () => {
    setIsExtendingRoomTimeAnchorEl(null);
  };

  const openDeletionRoom = Boolean(isDeletingRoomAnchorEl);
  const openExtendingRoomTime = Boolean(isExtendingRoomTimeAnchorEl);
  const deletionRoomId = openDeletionRoom ? 'simple-popover' : undefined;
  const extendingRoomTimeId = openExtendingRoomTime ? 'simple-popover' : undefined;

  return (
    <div>
      <BootstrapDialog
        onClose={() => setRoomTopMenuOptionsOpen(false)}
        aria-labelledby="customized-dialog-title"
        open={roomTopMenuOptionsOpen}
        TransitionComponent={Transition}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          Room Menu
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={() => setRoomTopMenuOptionsOpen(false)}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          <TabContext value={tabValue}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <TabList onChange={handleTabChange} aria-label="lab API tabs example">
                <Tab label="Share Room" value="1" />
                <Tab label="Settings" value="2" />
              </TabList>
            </Box>

            <TabPanel value="1">
              <Box
                component="form"
                noValidate
                autoComplete="off"
                className={classes.customTabPanelStyles}
              >
                <FormControl sx={{ mb: 2, width: '100%' }} variant="outlined">
                  <InputLabel htmlFor="outlined-adornment-password">Regular's Link</InputLabel>
                  <OutlinedInput
                    id="outlined-adornment-password"
                    type="text"
                    value={regularModeRoomUrl}
                    disabled
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="copy regular's link"
                          edge="end"
                          onClick={() => handleCopyClick(regularModeRoomUrl)}
                        >
                          <ContentCopyIcon />
                        </IconButton>
                      </InputAdornment>
                    }
                    label="Regular's Link"
                  />
                </FormControl>

                <FormControl sx={{ mt: 2, width: '100%' }} variant="outlined">
                  <InputLabel htmlFor="outlined-adornment-password">Spectator's Link</InputLabel>
                  <OutlinedInput
                    id="outlined-adornment-password"
                    type="text"
                    value={spectatorModeRoomUrl}
                    disabled
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="copy spectator's link"
                          edge="end"
                          onClick={() => handleCopyClick(spectatorModeRoomUrl)}
                        >
                          <ContentCopyIcon />
                        </IconButton>
                      </InputAdornment>
                    }
                    label="Spectator's Link"
                  />
                </FormControl>
              </Box>

            </TabPanel>

            <TabPanel value="2">
              <Box
                className={classes.customTabPanelStyles}
              >
                <Paper>
                  <MenuList>
                    {isCurrentUserMainAdmin ? (<div>
                      <MenuItem aria-describedby={deletionRoomId} variant="contained" onClick={handleAdminDeletionClick}>
                        <ListItemIcon>
                          <DeleteIcon fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Delete</ListItemText>
                      </MenuItem>
                      <Popover
                        id={deletionRoomId}
                        open={openDeletionRoom}
                        anchorEl={isDeletingRoomAnchorEl}
                        onClose={handleAdminDeletionClose}
                        anchorOrigin={{
                          vertical: 'bottom',
                          horizontal: 'left',
                        }}
                      >
                        <AdminRoomDeletion
                          roomName={roomName}
                          roomId={roomId}
                          handleAdminDeletionClose={handleAdminDeletionClose}
                        />
                      </Popover>
                      <Divider />
                    </div>) : null}

                    <MenuItem aria-describedby={extendingRoomTimeId} variant="contained" onClick={handleUserExtendingRoomTimeClick}>
                      <ListItemIcon>
                        <DeleteIcon fontSize="small" />
                      </ListItemIcon>
                      <ListItemText>Extend Room Time</ListItemText>
                    </MenuItem>
                    <Popover
                        id={extendingRoomTimeId}
                        open={openExtendingRoomTime}
                        anchorEl={isExtendingRoomTimeAnchorEl}
                        onClose={handleUserExtendingRoomTimeClose}
                        anchorOrigin={{
                          vertical: 'bottom',
                          horizontal: 'left',
                        }}
                      >
                        <UserExtendingRoomTime
                          roomName={roomName}
                          roomId={roomId}
                          handleUserExtendingRoomTimeClose={handleUserExtendingRoomTimeClose}
                        />
                      </Popover>
                  </MenuList>
                </Paper>
              </Box>

            </TabPanel>

          </TabContext>
        </DialogContent>
      </BootstrapDialog>
      {/* 
      {
        isDeletingRoom ? <AdminRoomDeletion
          roomName={roomName}
          roomId={roomId}
        /> : null
      } */}
    </div>
  );
}
